import { sha256 } from '@noble/hashes/sha256';
import * as secp from '@noble/secp256k1';
import { derivePublicKey, pubkeyToAddress } from '@gonka-wallet/crypto';
import { makeSignBytes } from '@cosmjs/proto-signing';
import { encodeSecp256k1Signature } from '@cosmjs/amino';
import { CryptoError } from './errors.js';
export function createGonkaSigner(privateKey) {
    const pubkey = derivePublicKey(privateKey);
    const address = pubkeyToAddress(pubkey);
    const account = {
        address,
        algo: 'secp256k1',
        pubkey,
    };
    return {
        async getAccounts() {
            return [account];
        },
        async signDirect(signerAddress, signDoc) {
            if (signerAddress !== address) {
                throw new CryptoError('SIGNING_FAILED', 'errors.tx.signerMismatch', `signer address ${signerAddress} does not match wallet ${address}`);
            }
            const bytes = makeSignBytes(signDoc);
            const hash = sha256(bytes);
            const sig = await secp.signAsync(hash, privateKey, { lowS: true });
            const signatureBytes = sig.toCompactRawBytes();
            const stdSignature = encodeSecp256k1Signature(pubkey, signatureBytes);
            return {
                signed: signDoc,
                signature: stdSignature,
            };
        },
    };
}
//# sourceMappingURL=signer.js.map